import { useEffect, useState } from "react";
import { fmtDate } from "@/lib/dates";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { UserCheck, UserX, Inbox } from "lucide-react";

export default function PendingApprovals() {
  const [reqs, setReqs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/registrations/pending").then((r) => setReqs(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try { await api.post(`/registrations/${id}/approve`); toast.success("Member approved — they can now sign in"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not approve"); }
  };
  const reject = async (id) => {
    try { await api.post(`/registrations/${id}/reject`); toast.success("Request rejected"); load(); }
    catch { toast.error("Could not reject"); }
  };

  return (
    <div className="space-y-6" data-testid="approvals-page">
      <div>
        <h2 className="font-serif text-2xl font-bold text-[#1C241B]">Pending Approvals</h2>
        <p className="text-sm text-[#7A8A78]">New member sign-ups awaiting your approval. Approving creates their member record and lets them sign in.</p>
      </div>
      {!loading && reqs.length === 0 && (
        <Card className="p-10 text-center bg-white border border-[#E5E0D8]" data-testid="approvals-empty">
          <Inbox className="h-8 w-8 mx-auto text-[#B9C3B5]" />
          <p className="mt-3 text-sm text-[#7A8A78]">No pending registrations right now.</p>
        </Card>
      )}
      <div className="space-y-3">
        {reqs.map((r) => (
          <Card key={r.id} data-testid={`approval-${r.id}`} className="p-5 bg-white border border-[#E5E0D8] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="min-w-0">
              <p className="font-semibold text-[#1C241B]">{r.name}</p>
              <p className="text-sm text-[#7A8A78]">{r.email}{r.dob ? ` · DOB ${fmtDate(r.dob)}` : ""}</p>
            </div>
            <div className="flex gap-2 shrink-0">
              <Button onClick={() => approve(r.id)} data-testid={`approve-${r.id}`} className="bg-[#2D5A27] hover:bg-[#23471F] text-white">
                <UserCheck className="h-4 w-4 mr-2" /> Approve
              </Button>
              <Button onClick={() => reject(r.id)} variant="outline" data-testid={`reject-${r.id}`} className="border-[#9A3412] text-[#9A3412] hover:bg-[#FBEAE4]">
                <UserX className="h-4 w-4 mr-2" /> Reject
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
